import React from 'react';

// Define the OptionsFromEnum component
const FilterOptionEnum = ({ enumObject }) => (
    <>
        {Object.keys(enumObject).map(key => (
            <option key={key} value={key}>{enumObject[key]}</option>
        ))}
    </>
);

export default FilterOptionEnum;